import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { MirrorService } from 'services/MirrorService';

import { ORGANIC_PARTNER_IDS } from 'helpers/constants';
import { getAuthenticated } from 'store/auth/selectors';
import { isOrganicPartnerIdSelector } from 'store/common/selectors';

import { useSystemSearchQueries } from './useSystemSearchQueries';

export const usePartnerId = () => {
  const isOrganicPartnerIdFromInit = useSelector(isOrganicPartnerIdSelector);
  const isAuthenticated = useSelector(getAuthenticated);

  const { getPartnerIdQuery } = useSystemSearchQueries();

  const { value: partnerIdQueryValue } = getPartnerIdQuery();

  const isOrganicPartnerId = useMemo(() => {
    if (isAuthenticated) {
      return isOrganicPartnerIdFromInit;
    }

    return (
      ORGANIC_PARTNER_IDS.includes(String(partnerIdQueryValue)) ||
      !partnerIdQueryValue
    );
  }, [isAuthenticated, isOrganicPartnerIdFromInit, partnerIdQueryValue]);

  const isOrganicPartnerIdOnMainMirror = useMemo(
    () => MirrorService.isMainMirror && isOrganicPartnerId,
    [isOrganicPartnerId]
  );

  return { isOrganicPartnerId, isOrganicPartnerIdOnMainMirror };
};
